export const VALIDATORS = {
  "userName": [
    {
      errorName: "required",
      errorDescription: "Yêu cầu nhập tên tài khoản"
    },
    {
      errorName: "pattern",
      errorDescription: "Tên tài khoản chỉ chấp nhận chữ cái, số, dấu '._'"
    },
    {
      errorName: "minlength",
      errorDescription: "Ít nhất 6 ký tự"
    },
    {
      errorName: "exist",
      errorDescription: "Vui lòng thử tên khác."
    }
  ],
  "name": [
    {
      errorName: "required",
      errorDescription: "Yêu cầu nhập tên người dùng"
    }
  ],
  "email": [
    {
      errorName: "email",
      errorDescription: "Email không hợp lệ"
    }
  ],
  "phoneNumber": [
    {
      errorName: "pattern",
      errorDescription: "Số điện thoại không hợp lệ"
    }
  ],
  "password": [
    {
      errorName: "required",
      errorDescription: "Yêu cầu nhập mật khẩu"
    },
    {
      errorName: "pattern",
      errorDescription: "Mật khẩu phải có ký tự đặc biệt, chữ viết thường, viết hoa và số ít nhất 8 ký tự"
    },
    {
      errorName: "minlength",
      errorDescription: "Ít nhất 6 ký tự"
    },
  ],
  "repeatPassword": [
    {
      errorName: "required",
      errorDescription: "Yêu cầu nhập lại mật khẩu"
    },
    {
      errorName: "notMatch",
      errorDescription: "Mật khẩu không khớp"
    },
    {
      errorName: "minlength",
      errorDescription: "Ít nhất 6 ký tự"
    },
  ]
}
